export default "__VITE_ASSET__6DmDK3IB__"